import React from "react";
function Footer()
{
    return(
        <>
        <div className="Footer">
            <p>&copy; 2021 Next Health Media LLC,</p>
            <p>All Rights Reserved</p>

        </div>
        </>
    )
}
export default Footer;